
import { RightOutlined } from "@ant-design/icons";
import {Row, Col, Button, Form, Input, Select, Space} from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';

import clubMasterService from "../../../api/club.service";
import clubService from "../../../api/clubaffiliation.service";

import { EDIT_MODE, SUCCESS_STATUS } from "../../../utility/Constants";

import CustomMessage from "../../common/CustomMessage";
import { addClub } from "../../../store/clubSlice"; 
import commonUtility from "../../../utility/Utils";

const { Option } = Select;



const ClubEntry = ({ data , onDrawerClose}) => {

    const dispatch = useDispatch();

    // console.log(data)
    const [isFormResponse, setIsFormResponse] = useState(false);
    const [formResponseMessage, setFormResponseMessage] = useState("");
    const [formResponseStatus, setFormResponseStatus] = useState("");
   
    const [afilliationStartYear, setAfilliationStartYear] = useState([]);
    const [afilliationEndYear, setAfilliationEndYear] = useState([]);
   
    const [formDefaultValues, setFormDefaultValues] = useState({
        club_id: data.club_id,
        designation: data.designation,
        club_name: data.club_name,      
        email: data.email,
        address: data.address,
        mode: data.mode,
        starting_affiliation_year: data.starting_affiliation_year,
        gstin: data.gstin
    });

    const [mode, setMode] = useState(data.mode);


    const [form] = Form.useForm();

    const onClubSave = async (values) => {
        //   console.log(values);
        const data = { formdata: values };

        const response = clubMasterService.save(data).then((resdata) => {

            setIsFormResponse(true);
            setFormResponseStatus(resdata.response_status);
            setFormResponseMessage(resdata.response_msg);

            const x = {
                club_id:commonUtility.randomID(),
                programme_id:values.programme_id,
                programme_group_id:values.programme_group_id,
                
            }
            dispatch(addClub(x))
        });
    };


    const hideResponseMessage = () => {
        setIsFormResponse(false);
        if(mode=="ADD") {
            form.resetFields();
            form.setFieldsValue({
                club_id: formDefaultValues.club_id,
                mode: formDefaultValues.mode,
                is_active: "Y",
            })
        }
    }
    

    useEffect(() => {

        mode == EDIT_MODE ?
            form.setFieldsValue({
                club_id: formDefaultValues.club_id,
                designation: formDefaultValues.designation,
                club_name: formDefaultValues.club_name,      
                email: formDefaultValues.email,
                address: formDefaultValues.address,                            
                starting_affiliation_year: formDefaultValues.starting_affiliation_year,
                gstin: formDefaultValues.gstin
            })
            :
            form.setFieldsValue({
                club_id: 0,
                designation:'',
                club_name: '',
                email: '',
                address:'',                
                starting_affiliation_year:'',
                gstin:'',
                mode: data.mode               
            });

        form.setFieldsValue(formDefaultValues)
       

    }, [form]);


    useEffect(() => {
        clubService.clubYearList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                //setProgrammeList(res.data.response_data);
                setAfilliationStartYear(res.data.response_data);
                setAfilliationEndYear(res.data.response_data);
            }
        });

    }, []);

   

   

    return (
        <div>
            <div className="form-input-style">

                <Row className="" style={{ background: "transparent" }}>
                    <Col className="" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onClubSave}
                            autoComplete="off"
                        // initialValues={formDefaultValues}
                        >

                            {/* <Row gutter={20}>
                            <Col className="gutter-row" xs={24} xl={24}>
                                <h5>Note: * fields are required</h5>
                            </Col>
                        </Row> */}
                            <Row gutter={20}>

                            <Form.Item name="club_id" label="club_id" hidden={true}>
                                <Input type="text" />
                            </Form.Item>
                            <Form.Item name="mode" label="mode" hidden={true}>
                                <Input type="text" />
                            </Form.Item>

                               <Col xs={24} xl={24}>
                                    <Form.Item name="club_name" label="Club Name" rules={[
                                        {
                                            required: true,
                                            message: 'Club name is required',
                                        },
                                    ]}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>

                                

                                <Col xs={24} xl={12}>
                                    <Form.Item name="designation" label="Designation" rules={[
                                        {
                                            required: true,
                                            message: 'Designation is required',
                                        },
                                    ]}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="email" label="Email" >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="gstin" label="GSTIN" >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                            
                                <Col xs={24} xl={12}>
                                            <Form.Item
                                                name="starting_affiliation_year"
                                                label="Club Affiliation Start Year"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Select upto year',
                                                    },
                                                 ]}                                            >
                                                <Select className="text-left">
                                                    <Option value="">Select</Option>
                                                    {afilliationEndYear.length > 0
                                                        ? afilliationEndYear.map((end_year_obj) => (
                                                            <Option
                                                                key={end_year_obj.affiliation_year_id}
                                                                value={end_year_obj.affiliation_year_id}
                                                            >
                                                                {`${end_year_obj.start_year} - ${end_year_obj.end_year}`}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                                            
                                <Col xs={24} xl={24}>
                                    <Form.Item name="address" label="Address" >
                                        <TextArea rows={2} placeholder="" />
                                    </Form.Item>
                                </Col>                               
                              

                                <Col xs={24} xl={22}>
                                    <Form.Item name="" label=" " style={{ textAlign: 'right' }}>
                                        <Space>
                                            <Button htmlType="submit"  className="custom-button-green" >
                                                Save <RightOutlined />
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Col>

                            </Row>
                        </Form>



                    </Col>
                </Row>
                {
                    // isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} /> : ''
                    isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} /> : ''
                }




            </div>
        </div>
    );
};

export default ClubEntry
